<template>
  <div class="card" v-if="facture">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :error="error"
                           :title="'editionFacture.problemOccurred'"
                           @close="error = $event"/>
      <avertissement-msg-component :title="'general.warning'"
                                   :avertissement="checkDateLignes"
                                   :can-close="false"
                                   :messages="[{ message: msgAvertissement }]">
      </avertissement-msg-component>
      <div class="columns is-centered is-multiline mgt-20px">
        <div class="column is-1">
          <b-icon
            icon="information" type="is-primary"
            custom-class="popup-icon">
          </b-icon>
        </div>
        <div class="column is-12 has-text-centered is-size-5">
          {{ toFinalBillTitle }}
        </div>
        <div class="column is-12 has-text-centered pdt-0 is-size-6" v-if="!exerciceOk">
          <div class="columns">
            <b-icon icon="alert" custom-size="mdi-24px" type="is-warning"
                          class="column is-1"></b-icon>
            <span class="column is-11 has-text-warning">{{errorsExercice}}</span>
          </div>
        </div>

        <div class="column is-12 has-text-centered has-text-weight-bold">
          {{ toFinalBillText }}
        </div>
        <div class="column is-12 pdt-0" v-if="haveVenteInterne">
          <b-checkbox v-model="impactAchatVenteInterne" class="mgt-1em">
            {{ $t('detailFacture.popUpAvoir.propagationAvoirPartielVenteInterne') }}
          </b-checkbox>
        </div>
        <footer class="column is-12 has-text-centered buttons">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered"
            @click="$parent.close()">
            {{ $t('editionFacture.actions.revert')}}
          </button>
          <button v-if='!error'
            class="button is-primary has-text-centered"
            @click="valider()" >
            {{ $t('editionFacture.actions.toFinalBill')}}
          </button>
          <router-link class='button is-outlined'
                       v-else
                       :class="{'text-access-no-permission':
                     !checkPermissions(permFacture.maj)}"
                       :to='{ name: getRouteName , params: { id: facture.id } }'>
            {{ labelButtonCorriger }}
          </router-link>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import { brouillon2Facture as brouillon2FactureVente, get } from '@/api/facture/index';
import * as devisConf from '@/configuration/devisConf';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { FACTURES } from '@/configuration/permissionsBodacConf';
import { brouillon2Facture as brouillon2FactureAchatARapprocher } from '@/api/factureAchatARapprocher/index';
import { brouillon2Facture as brouillon2FactureAchat } from '@/api/factureAchat/index';
import { checkExercice } from '@/api/compta/exerciceComptable/index';
import avertissementMsgComponent from '@/components/general/avertissementMsgComponent';
import validationEcriture from '@/services/ecritureComptable/validation';
import { siteHasHolding } from '@/services/general/holding';
import loadFactureAchatVenteInterne
  from '@/services/facture/factureAchat/loadFactureAchatVenteInterne';
import validationChampsObligatoireFacture from '@/services/devisCommandes/validation/validationChampsObligatoireFacture';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'confirmation-enregistrement-definitif',
  components: {
    errorMsgComponent,
    avertissementMsgComponent,
  },
  props: {
    facture: {
      type: Object,
      required: true,
    },
    isAvoir: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTitreRecette: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      messages: [],
      error: false,
      permFacture: FACTURES,
      vente: devisConf.SENS_VENTE,
      exerciceOk: true,
      errorsExercice: '',
      impactAchatVenteInterne: true,
      facturesAchat: [],
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    haveVenteInterne() {
      return this.isAvoir && siteHasHolding() && this.facturesAchat.length > 0;
    },
    checkDateLignes() {
      return (this.facture.sens === devisConf.SENS_ACHAT
        && this.facture.lignesCommande.some((ligne) => {
          return (!ligne.dateDebut || !ligne.dateFin)
            || (moment(ligne.dateDebut).isSame(moment(ligne.dateFin)));
        }));
    },
    isFactureAchat() {
      return this.facture.sens === devisConf.SENS_ACHAT
        && this.facture.module === devisConf.MODULE_ACHAT
        && this.facture.type === devisConf.TYPE_FACTURE;
    },
    toFinalBillTitle() {
      let title = 'editionFacture.toFinalBillTitle';
      if (this.isTitreRecette) title = 'detailTitreRecette.toFinalBillTitle';
      if (this.isFactureAchat) title = 'detailFactureAchat.toFinalBillTitle';
      return this.$t(title, { code: this.facture.code });
    },
    toFinalBillText() {
      let text = 'editionFacture.toFinalBillText';
      if (this.isTitreRecette) text = 'detailTitreRecette.toFinalBillText';
      if (this.isFactureAchat) text = 'detailFactureAchat.toFinalBillText';
      return this.$t(text);
    },
    labelButtonCorriger() {
      let label = 'editionFacture.actions.amend';
      if (this.isTitreRecette) label = 'editionTitreRecette.actions.amend';
      if (this.isFactureAchat) label = 'detailFactureAchat.actions.amend';
      return this.$t(label);
    },
    msgAvertissement() {
      let msg = 'editionCreationDepenseBailleur.popUpPrevention.title';
      if (this.isFactureAchat) msg = 'addEditFactureAchat.popUpPrevention.title';
      return msg;
    },
    getRouteName() {
      const { sens } = this.facture;
      let routeName = '';
      if (this.isTitreRecette) routeName = 'm.gabed.titre_recette-edition';
      if (this.isFactureAchat) routeName = 'm.achat.factures';
      if (!this.isTitreRecette && !this.isFactureAchat && sens === devisConf.SENS_ACHAT) {
        routeName = 'm.baux.facture_achat-edition';
      }
      if (sens === devisConf.SENS_VENTE) {
        routeName = 'm.bodac.factures-edition';
      }
      return routeName;
    },
  },
  methods: {
    async propagationPourVenteInterne() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (!this.isAvoir || !siteHasHolding() || !this.facture.referenceId) {
          loadingComponent.close();
          return;
        }
        const realFacture = (await get(this.facture.referenceId)).data.result;
        const societe = this.societesInformations
          .find((s) => s.id === realFacture.societeId);
        this.facturesAchat = await loadFactureAchatVenteInterne(
          realFacture, societe.listeSocieteTiers, false,
        );
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async valider() {
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      this.error = false;
      try {
        if (this.facture.sens === devisConf.SENS_VENTE) {
          await brouillon2FactureVente(this.facture.id, this.impactAchatVenteInterne);
        } else if (this.facture.aRapprocher) {
          await brouillon2FactureAchatARapprocher(this.facture.id);
        } else await brouillon2FactureAchat({ id: this.facture.id });
        loadingComponent.close();
        await this.$router.go(0);
      } catch (e) {
        if (e.response) {
          this.error = true;
          validationDevisCommande(e.response,
            this.messages,
            false,
            this.isAvoir ? devisConf.SOUS_TYPE_AVOIR : devisConf.TYPE_FACTURE,
            this.isTitreRecette);
          validationChampsObligatoireFacture(e.response, this.messages);
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await checkExercice(this.facture.societeId, this.facture.dateDevisCommande)
        .then(response => {
          this.exerciceOk = response.data.result.state;
          if (response.data.result.errors !== null && response.data.result.errors.length >= 1) {
            const messages = [];
            validationEcriture(this.$i18n, response.data.result.errors, messages);
            this.errorsExercice = this.$i18n.t(messages[0].message, messages[0].parametres);
          }
        });
      await this.propagationPourVenteInterne();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
